import jwtDecode from "jwt-decode";

export const checkIfTokenExpired = (token) => {
  if (typeof token !== "string") return true;
  return jwtDecode(token).exp < Date.now() / 1000;
};
